export const taskListDropDownsConfig = [
    { dropdownName: "CommitteeWorkgroupTypes", fieldId: "groupTypeId" },
    { dropdownName: "ParentRelational", fieldId: "parentTypeId" }
];

export const addExcoMemberConfigs = [
    { dropdownName: "ContributionRole", fieldId: "eXCOPosition" },
];